import api from './index';
//
let exports = {};

exports.getMerchantDtoList = function (data, callback) {// 获取服务商列表
    api.post('/rent/servc/merchant/dto/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getMerchantDtoListByIds = function (params, callback) {
    api.post('/rent/servc/merchant/dto/list/get/by/ids')
    .data(params)
    .done(callback)
    .go();
};

exports.getMerchantDtoById = function (data, callback) {// 获取服务商
    api.post('/rent/servc/merchant/dto/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// - 【设备明细维修统计】 and 【机构待修设备明细统计表】
exports.statisShopDeviceSvcSubNoStatisList = function (data, callback) {
    api.post('/rent/servc/svcSubNo/statis/list/get/by/comId')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getServcWorkVoucherPageList = function (data, callback) {// 租赁服务工单列表
    api.post('/rent/servc/servc/work/voucher/paged/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getServcWorkAddItemList = function (params, callback) {
    api.get('/rent/servc/servc/work/add/item/get')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getDevcMaintVoucherById = function (params, callback) {
    api.get('/rent/servc/devc/maint/voucher/get')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getServcWorkImgFileListByVoucherId = function (params, callback) {
    api.get('/rent/servc/servc/work/img/file/get/by/voucherId')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getServcWorkImgFileById = function (data, callback) {
    api.get('/servcDeliv/servc/work/img/file/get/by/id')
    .params(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.deleteServcWorkImgFile = function (data, callback) {
    api.post('/servcDeliv/servc/work/img/file/delete')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.updateServcWorkImgFile = function (data, callback) {
    api.post('/servcDeliv/servc/work/img/file/update')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getServcWorkImgFileList = function (data, callback) {
    api.post('/rent/servc/servc/work/img/file/list')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.saveServcWorkImgFile = function (data, callback) {
    api.post('/rent/servc/servc/work/img/file/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//
exports.updateServcWorkVoucherForShopDeviceByVendorSn = function (data, callback) {
    api.post('/rent/servc/servc/work/sync/device/by/vendorsn')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//
exports.saveMerchantBizRel = function (params, callback) {// 保存商户业务关系
    api.post('/rent/servc/merchant/biz/rel/save/do')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getMerchantBizRelPeerMerchantIds = function (data, callback) {// 获取当前商户的给定商户类型的（存在于给定的关系商户id列表中的）关系商户ids
    api.post('/rent/servc/merchant/biz/rel/peerMerchantIds/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 确认完成-批量执行
exports.doBatchConfirmCompleted = function (data, callback) {
    api.post('/rent/servc/servc/work/voucher/check/batch/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 保存服务评价
exports.saveOrderServcEval = function (data, callback) {
    api.post('/rent/servc/order/servc/eval/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 保存服务评价
exports.refuseServcWorkVoucherChecked = function (data, callback) {
    api.post('/rent/servc/servc/work/voucher/checked/refuse/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 保存服务评价
exports.getOrderServcEvalListForDetailer = function (data, callback) {
    api.post('/rent/servc/order/servc/eval/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// =================================== 检验流程管理  ===================================
//
exports.getDevcInspectFlowPageList = function (data, callback) {        // 设备检验流程列表
    api.post('/rent/servc/devc/inspect/flow/page/list/get')
    .data(data)
    .done(callback)
    .go();
};
//
exports.getDevcInspectFlowInfo = function (params, callback) {        // 设备检验流程详情
    api.get('/rent/servc/devc/inspect/flow/info/get')
    .params(params)
    .done(callback)
    .go();
};
//
exports.saveDevcInspectFlow = function (data, callback) {        // 设备检验流程-保存
    api.post('/rent/servc/devc/inspect/flow/save/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.updateDevcInspectFlow = function (data, callback) {        // 设备检验流程-修改
    api.post('/rent/servc/devc/inspect/flow/update/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.updateDevcInspectFlowForDisabled = function (data, callback) {        // 设备检验流程-启禁用
    api.post('/rent/servc/devc/inspect/flow/update/for/disabled/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.deleteDevcInspectFlow = function (data, callback) {        // 设备检验流程-删除
    api.post('/rent/servc/devc/inspect/flow/delete/do')
    .data(data)
    .done(callback)
    .go();
};
// ================================ 凭单检查项 ================================
exports.getDevcMaintCheckItemPageList = function (data, callback) {// 设备维护保养检查项分页列表
    api.post('/rent/servc/devc/maint/check/item/page/list/get')
    .data(data)
    .done(callback)
    .go();
};
//
exports.getDevcMaintCheckItemById = function (params, callback) {// 设备维护保养检查项
    api.get('/rent/servc/devc/maint/check/item/get/by/id')
    .params(params)
    .done(callback)
    .go();
};
//
exports.getDevcMaintCheckItemList = function (data, callback) {// 设备维护保养检查项分页列表
    api.post('/rent/servc/devc/maint/check/item/list/get')
    .data(data)
    .done(callback)
    .go();
};
//
exports.doSaveDevcMaintCheckItem = function (data, callback) {// 保存设备维护保养检查项
    api.post('/rent/servc/devc/maint/check/item/save/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.doDisabledDownDevcMaintCheckItem = function (data, callback) {// 禁用设备维护保养检查项
    api.post('/rent/servc/devc/maint/check/item/disabled/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.doCopyDevcMaintCheckItem = function (data, callback) {// 禁用设备维护保养检查项
    api.post('/rent/servc/devc/maint/check/item/copy/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.moveUpOrDownDevcMaintCheckItem = function (data, callback) {// 上下移动设备维护保养检查项
    api.post('/rent/servc/devc/maint/seq/move/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.doDeleteDevcMaintCheckItem = function (data, callback) {// 删除设备维护保养检查项
    api.post('/rent/servc/devc/maint/check/item/delete/do')
    .data(data)
    .done(callback)
    .go();
};
//
// -------------------------------------- 凭单管理 --------------------------------------
// 获取pdf模板信息
exports.getDevcMaintPdfTpl = function (data, callback) {
    api.get('/rent/servc/devc/maint/proof/pdfTpl/get')
    .data(data)
    .done(callback)
    .go();
};

// 凭单列表
exports.getDevcMaintProofList = function (data, callback) {
    api.post('/rent/servc/devc/maint/proof/list/get')
    .data(data)
    .done(callback)
    .go();
};

// 凭单详情（包含子项）
exports.getDevcMaintProofInfo = function (params, callback) {
    api.get('/rent/servc/devc/maint/proof/info/get')
    .params(params)
    .done(callback)
    .go();
};
// 启、禁用
exports.updateDevcMaintProofForDisabled = function (data, callback) {
    api.post('/rent/servc/devc/maint/proof/disabled/update/do')
    .data(data)
    .done(callback)
    .go();
};
// 保存
exports.saveDevcMaintProofInfo = function (data, callback) {
    api.post('/rent/servc/devc/maint/proof/save/do')
    .data(data)
    .done(callback)
    .go();
};
// 凭单-检查项-排序
exports.moveUpOrDownDevcMaintProofCheckItem = function (data, callback) {
    api.post('/rent/servc/devc/maint/proof/checkItem/seq/move/do')
    .data(data)
    .done(callback)
    .go();
};
// 删除
exports.deleteDevcMaintProof = function (data, callback) {
    api.post('/rent/servc/devc/maint/proof/delete/do')
    .data(data)
    .done(callback)
    .go();
};

exports.getMaxWorkAttachFileCount = function (params, callback) {
    api.get('/rent/servc/max/work/attach/file/count/get')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};

// 获取附件标签列表
exports.getAttTagList = function (data, callback) {
    api.post('/rent/servc/att/tags/get')
    .data(data)
    .done(callback)
    .go();
};
exports.getAttTagListByAttAspect = function (filter, callback) {
    let data = {};
    data.filterItems = filter;
    exports.getAttTagList(data, callback);
};
//
exports.getUnivCheckCombList = function (params, callback) {
    api.get('/rent/servc/univ/check/comb/list/get')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/rentServc.js
// module id = 36
// module chunks = 1